import React, { Component } from "react";
import { connect } from "react-redux";

import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action, insertUpdateCmsSubheader_action, insertUpdateCMSGovtLogo_action, updateCmsGovtLogoStatus_action } from "../../actions/cms_action/cmsAction";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../utils/withRouter";
import { BASE_URL, toastError, toastSuccess } from "../../utils/constants";
import { Tab, Nav } from "react-bootstrap";

class cmsHeaderMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            isLoading: false,
            cmsMenuData: [],
            cmsFooterData: [],
            cmsSubheaderData: [],
            editingRowId: null,
            govtLogoList: [],
            downloadUrl: ''
        };
    }

    componentDidMount() {
        this.getCmsContent();
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

    }
    handleEdit = (tableId) => {
        this.setState({ editingRowId: tableId });
    };

    handleChange = (e, key, value) => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const updatedData = cmsSubheaderData.map((row) => {
            if ((row.tableId || row.SubheaderID) === editingRowId) {
                return { ...row, [key]: value !== undefined ? value : e.target.value };
            }
            return row;
        });
        this.setState({ cmsSubheaderData: updatedData });
    };
    handleAddRow = (tableId) => {
        const { cmsSubheaderData } = this.state;
        const index = cmsSubheaderData.findIndex(row => (row.tableId || row.SubheaderID) === tableId);

        const newRow = {
            tableId: Date.now(),
            SubheaderID: null,
            SubheaderName: "",
            ViewType: "",
            SocialType: "",
            Link: "",
            isActive: false,
            isPublish: false
        };

        const updatedData = [...cmsSubheaderData.slice(0, index + 1), newRow, ...cmsSubheaderData.slice(index + 1)];
        this.setState({ cmsSubheaderData: updatedData, editingRowId: newRow.tableId });
    };
    async getCmsContent() {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(1, 'home');

            if (data.error !== 1) {
                const flatList = data?.data?.[1] || [];
                const cmsSubheaderData = data?.data[4] !== "" ? data?.data[4] : []

                const menuMap = {};
                flatList.forEach(item => {
                    item.id = uuidv4();
                    item.children = [];
                    item.showSave = false;
                    menuMap[item.MenuID] = item;
                });

                const rootMenus = [];
                flatList.forEach(item => {
                    if (item.ParentID) {
                        if (menuMap[item.ParentID]) {
                            menuMap[item.ParentID].children.push(item);
                        }
                    } else {
                        rootMenus.push(item);
                    }
                });

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data?.[1],
                    cmsFooterData: data?.data?.[2][0],
                    cmsSubheaderData: cmsSubheaderData,
                    menuList: rootMenus,
                    govtLogoList: data?.data?.[6] ? data?.data?.[6] : []
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleInputChange = (id, field, value, parent = null) => {
        // Prevent spaces in URL field
        if (field === 'Url') {
            value = value.replace(/\s/g, '');
        }

        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    return { ...menu, [field]: value, showSave: true };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }));
    };


    saveRowLocally = (id) => {
        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    const title = menu.Title?.trim();
                    const url = menu.URL?.trim();

                    if (!title || !url) {
                        toastError('Both Title and URL are required.');
                        return menu; // Do not update showSave if validation fails
                    }

                    return { ...menu, showSave: false };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }, () => {
            this.submitMenu()
        }));
    };


    addNewMenu = (parentId = null) => {
        const { menuList } = this.state;

        if (!parentId) {
            // Adding a new parent menu
            const maxSequence = menuList.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
            const newMenu = {
                id: menuList.length,  // Use the index of the menuList as the id
                MenuID: null,
                ParentID: null,
                Title: "",
                Url: "",
                Sequence: maxSequence + 1,
                isActive: true,
                isPublish: true,
                children: [],
                showSave: true, id: uuidv4()
            };
            this.setState(prev => ({
                menuList: [...prev.menuList, newMenu],
            }));
        } else {
            // Adding a new child menu
            const updatedList = menuList.map(menu => {
                if (menu.id === parentId) {
                    const children = menu.children || [];
                    const maxChildSequence = children.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
                    const newChild = {
                        id: uuidv4(),
                        MenuID: null,
                        ParentID: parentId,
                        Title: "",
                        Url: "",
                        Sequence: maxChildSequence + 1,
                        isActive: true,
                        isPublish: true,
                        children: [],
                        showSave: true,
                    };
                    return {
                        ...menu,
                        children: [...children, newChild],
                    };
                }
                return menu;
            });
            this.setState({ menuList: updatedList });
        }
    };

    handleRemove = (menu, parent = null) => {
        if (menu.MenuID) {
            this.setState((prevState) => {
                const updatedList = prevState.menuList.map((item) => {
                    if (item.id === menu.id) {
                        return { ...item, isActive: false };
                    } else if (item.children) {
                        return {
                            ...item,
                            children: item.children.map((child) =>
                                child.id === menu.id ? { ...child, isActive: false } : child
                            ),
                        };
                    }
                    return item;
                });
                return { menuList: updatedList };
            });
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    };
    async deleteCmsMenu(menu, parent = null) {
        if (menu.MenuID) {
            try {
                this.setState({ isLoading: true });
                const isConfirm = window.confirm('Are you sure you want to remove this Menu?')
                if (isConfirm) {
                    const data = await this.props.deleteCmsMenu_action(menu.MenuID);

                    if (data.error !== 1) {
                        this.setState({ isLoading: false });
                        if (data.data !== "") {
                            toastSuccess(`Menu Deleted Successfully`)
                            this.getCmsContent();
                        }
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                }
            } catch (err) {
                console.error(err);
                this.setState({ isLoading: false });
            }
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    }

    onDragEnd = result => {
        const { source, destination, type } = result;
        if (!destination) return;

        if (type === "PARENT") {
            const items = Array.from(this.state.menuList);
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);
            this.setState({ menuList: items });
        } else {
            const parentId = type;
            const parent = this.state.menuList.find(menu => menu.id === parentId);
            const items = Array.from(parent.children);
            const [reorderedChild] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedChild);

            const updatedList = this.state.menuList.map(menu =>
                menu.id === parentId ? { ...menu, children: items } : menu
            );

            this.setState({ menuList: updatedList });
        }
    };

    renderMenuRow = (menu, index, parent = null) => {
        const isChild = !!parent;
        const isparent = menu == parent ? 1 : 0
        return (
            <Draggable key={menu.id} draggableId={menu.id.toString()} index={index}>
                {(provided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{ ...provided.draggableProps.style, backgroundColor: isChild ? "#f5f5f5" : isparent == 1 ? "#eee" : "white" }}
                    >
                        {/* <td>{menu.MenuID || "-"}</td>
                        <td>{menu.ParentID || "-"}</td> */}
                        <td style={{ width: '425px' }}>
                            <input style={{ width: '100%' }}
                                type="text"
                                placeholder="Title"
                                className="form-control"
                                value={menu.Title}
                                onChange={(e) => this.handleInputChange(menu.id, "Title", e.target.value, parent)}
                            />
                        </td>
                        <td style={{ width: '430px' }}>
                            <input
                                type="text"
                                placeholder="Url"
                                className="form-control"
                                value={menu.Url}
                                onChange={(e) => this.handleInputChange(menu.id, "Url", e.target.value, parent)}
                            />
                        </td>{console.log(parent, 'parent')}
                        <td className="text-center" style={{ width: '100px' }}>
                            {`${parent?.Sequence ? parent.Sequence + '.' : ''}${menu.Sequence}`}
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isActive", !menu.isActive, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isActive} value={menu.isActive} />
                                <label class="custom-control-label" ></label>
                            </div>
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isPublish} value={menu.isPublish} />
                                <label class="custom-control-label" ></label>
                            </div>

                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <div class="custom-control custom-checkbox"
                                onClick={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem, parent)} >
                                <input type="checkbox" class="custom-control-input" checked={menu.isMenuItem} value={menu.isMenuItem} />
                                <label class="custom-control-label" ></label>
                            </div>
                        </td>
                        <td className="text-right" style={{ width: '100px' }}>
                            {!isChild && (
                                <i className="far fa-plus-square" style={{ marginRight: '10px' }} onClick={() => this.addNewMenu(menu.id)} />
                            )}
                            <i className="fas fa-trash-alt" onClick={() => this.deleteCmsMenu(menu, parent)} />
                            {/* {menu.showSave && (
                                <button className="btn btn-sm btn-outline-primary" onClick={() => this.saveRowLocally(menu.id)}>Save</button>
                            )} */}
                        </td>
                    </tr>
                )}
            </Draggable>
        );
    };
    submitSubmenu = async () => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const selectedRow = cmsSubheaderData.find(row => (row.tableId || row.SubheaderID) === editingRowId);

        if (!selectedRow.SubheaderName) {
            toastError("Please Enter Name");
            return;
        }
        if (!selectedRow.ViewType) {
            toastError("Please Select View Type");
            return;
        }
        if (selectedRow.ViewType === "SM" && !selectedRow.SocialType) {
            toastError("Please Select Social Type");
            return;
        }
        if (!selectedRow.Link) {
            toastError("Please Provide Link");
            return;
        }

        try {
            this.setState({ isLoading: true });
            const data = await this.props.insertUpdateCmsSubheader_action(
                selectedRow.SubheaderID,
                selectedRow.SubheaderName,
                selectedRow.ViewType,
                selectedRow.SocialType,
                selectedRow.Link,
                selectedRow.isActive,
                selectedRow.isPublish
            );

            this.setState({ isLoading: false, editingRowId: null });

            if (data.error !== 1) {
                toastSuccess("Sub Menu Added Successfully");
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    };
    async submitMenu() {
        try {
            const { menuList } = this.state;
            this.setState({ isLoading: true });

            const flatMenuList = [];

            for (const parent of menuList) {
                const { children, ...parentData } = parent;

                // Validate if the parent has both Title and Url
                const hasInvalidParent = !parentData.Title?.trim() || !parentData.Url?.trim();
                if (hasInvalidParent) {
                    toastError('Kindly Enter Title and Url in all Menu');
                    this.setState({ isLoading: false });
                    return;
                }

                // If the parent has a MenuID, use that MenuID for the update
                const parentMenuID = parentData.MenuID || null;

                // Push only required fields for the parent menu
                flatMenuList.push({
                    MenuID: parentMenuID, // If it's new, it will be null, else the existing MenuID
                    ParentID: null, // Root menus don't have a parent
                    Title: parentData.Title,
                    Url: parentData.Url,
                    Sequence: parentData.Sequence,
                    isActive: parentData.isActive,
                    isPublish: parentData.isPublish,
                    isMenuItem: parentData.isMenuItem
                });

                // If there are child menus, process them
                if (Array.isArray(children)) {
                    for (const child of children) {
                        const hasInvalidChild = !child.Title?.trim() || !child.Url?.trim();
                        if (hasInvalidChild) {
                            toastError('Kindly Enter Title and Url in all Menu');
                            this.setState({ isLoading: false });
                            return;
                        }

                        // Use the parentMenuID for the child
                        flatMenuList.push({
                            MenuID: child.MenuID || null, // If it's new, it will be null, else the existing MenuID
                            ParentID: parentMenuID, // Parent MenuID for the child
                            Title: child.Title,
                            Url: child.Url,
                            Sequence: child.Sequence,
                            isActive: child.isActive,
                            isPublish: child.isPublish,
                            isMenuItem: child.isMenuItem
                        });
                    }
                }
            }

            // Call action to insert or update the menu items
            const data = await this.props.insertUpdateCmsMenu_action(flatMenuList);

            this.setState({ isLoading: false });

            if (data.error !== 1) {
                toastSuccess('Menu Added Successfully');
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    //cms govt logos
    handleFileChangeGovtLogo = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate size (<= 5 MB)
        if (file.size > 5 * 1024 * 1024) {
            alert("File size should be less than 5MB");
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState((prevState) => {
                const list = [...prevState.govtLogoList];
                // insert/update base64 for preview
                list[index].formfile = reader.result; // base64 string
                list[index].filename = file.name;
                list[index].filetype = file.type;
                list[index].filepath = ""; // clear filepath since it’s a new file upload
                return { govtLogoList: list };
            });
        };
        reader.readAsDataURL(file);
    };

    /** Handle Link URL change */
    handleLinkGovtLogoChange = (index, value) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            list[index].Link = value;
            return { govtLogoList: list };
        });
    };

    /** Add New Logo Card */
    addNewGovtLogo = () => {
        this.setState((prevState) => ({
            govtLogoList: [
                ...prevState.govtLogoList,
                {
                    GovtLogoID: null, // 0 for new insert
                    filename: "",
                    filetype: "",
                    formfile: "",
                    filepath: "",
                    Link: "",
                    isActive: false,
                    isPublish: false,
                    seqNo: prevState.govtLogoList.length + 1,
                },
            ],
        }));
    };
    /** Handle Toggles (Active / Publish) */
    handleToggleGovtLogo = (index, field) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            // toggle locally
            list[index][field] = !list[index][field];

            // call API for update case
            const logo = list[index];
            const isInsert = logo.GovtLogoID === 0;

            // Determine UpdateType
            let updateType = '';
            if (field === 'isActive') updateType = 'A';
            if (field === 'isPublish') updateType = 'P';

            // dispatch API for update case only
            if (!isInsert) {
                this.props.updateCmsGovtLogoStatus_action(
                    logo.GovtLogoID,
                    updateType,
                    logo.isActive,
                    logo.isPublish
                );
            }
            return { govtLogoList: list };
        });
    };

    /** Delete Logo Card */
    deleteGovtLogo = (index) => {
        this.setState((prevState) => {
            const list = [...prevState.govtLogoList];
            const logo = list[index];
            const isInsert = logo.GovtLogoID === 0;

            // if already inserted, call API for delete
            if (!isInsert) {
                if (!window.confirm("Are you sure you want to delete this logo?")) {
                    this.props.updateCmsGovtLogoStatus_action(
                        logo.GovtLogoID,
                        'D', // Delete
                        logo.isActive,
                        logo.isPublish
                    );
                }
            }

            // remove from UI state
            list.splice(index, 1);
            return { govtLogoList: list };
        });
    };

    /** Save (Insert or Update) */
    handleSaveGovtLogo = () => {
        if (this.state.govtLogoList.length == 0) {
            toastError("Please add atleast one logo");
            return;
        }
        const payload = this.state.govtLogoList.map((logo) => {
            return {
                GovtLogoID: logo.GovtLogoID,
                filepath: logo.filepath ? logo.filepath : logo.GovtLogoFilepath ? logo.GovtLogoFilepath : "",
                filename: logo.filename ? logo.filename : "",
                filetype: logo.filetype ? logo.filetype : "",
                formfile: logo.formfile ? logo.formfile : "",
                Link: logo.Link,
                isActive: logo.isActive,
                isPublish: logo.isPublish,
                seqNo: logo.seqNo,
            };
        });

        this.props
            .insertUpdateCMSGovtLogo_action(payload)
            .then((res) => {
                if (res.error !== 1) {
                    toastSuccess("Logos saved successfully");
                    this.getCmsContent();
                } else {
                    toastError(res.msg);
                }
            })
            .catch((err) => {
                toastError("Error saving logos");
                console.error("Error saving logos:", err);
            });
    };

    render() {
        const { menuList, cmsMenuData, cmsFooterData, cmsSubheaderData, govtLogoList, downloadUrl } = this.state;
        return (
            <>
                <Header headerNavs={cmsMenuData} />
                <main className="main-area fix">
                    <section className="slider__area-two">
                        <div className="swiper slider-active-two">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide slider__bg-two">
                                    <div className="container">
                                        <div className="slider__content-two header_text">
                                            <section>
                                                <div className="page-header" style={{ marginTop: '80px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <h2 className="mb-1 dashboard-tit py-0 blog-name mx-4">CMS Menu Master</h2>

                                                </div>
                                                <Tab.Container defaultActiveKey="Main">
                                                    <Nav
                                                        variant="tabs"
                                                        className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                                                        role="tablist"
                                                    >
                                                        <Nav.Item className="tabs-border">
                                                            <Nav.Link eventKey="Main" className="tabs-color">
                                                                Main Menu
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item className="tabs-border">
                                                            <Nav.Link eventKey="Sub" className="tabs-color">
                                                                Sub Menu
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item className="tabs-border">
                                                            <Nav.Link eventKey="govtLogo" className="tabs-color">
                                                                Header Logos
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    </Nav>
                                                    <Tab.Content className="edit-award-rofile-body pr-1">
                                                        <Tab.Pane eventKey="Main">
                                                            <button className="btn rounded-1 edit-submit-btn me-2 p-1 px-2 mb-3 mt-1" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                            <button className="btn rounded-1 add-sec-btn p-1 px-2 mb-3 mt-1" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '425px' }}>Title</th>
                                                                        <th style={{ width: '425px' }}>URL</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Sequence</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                                        <th className="text-center" style={{ width: '100px' }}>Menu Item</th>
                                                                        <th className="text-right" style={{ width: '100px' }}>Actions</th>
                                                                    </tr>
                                                                </thead>
                                                                <DragDropContext onDragEnd={this.onDragEnd}>
                                                                    <Droppable droppableId="menuList" type="PARENT">
                                                                        {(provided) => (
                                                                            <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                                                {menuList.length > 0 ?
                                                                                    menuList?.sort((a, b) => a.Sequence - b.Sequence)?.map((menu, index) => (
                                                                                        <React.Fragment key={menu.id}>
                                                                                            {this.renderMenuRow(menu, index)}
                                                                                            {menu.children && menu.children.length > 0 && (
                                                                                                <Droppable droppableId={menu.id} type={menu.id}>
                                                                                                    {(providedChild) => (
                                                                                                        <tr>
                                                                                                            <td className="pr-0" colSpan="7" style={{ paddingLeft: '7px', background: '#eee', }}>
                                                                                                                <table className="table mb-0">
                                                                                                                    <tbody ref={providedChild.innerRef} {...providedChild.droppableProps}>
                                                                                                                        {menu.children?.sort((a, b) => a.Sequence - b.Sequence)?.map((child, childIndex) =>
                                                                                                                            this.renderMenuRow(child, childIndex, menu)
                                                                                                                        )}
                                                                                                                        {providedChild.placeholder}
                                                                                                                    </tbody>
                                                                                                                </table>
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    )}
                                                                                                </Droppable>
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    )) : <>
                                                                                        <tr><td colSpan={6}>No Record Found</td></tr>
                                                                                    </>
                                                                                }
                                                                                {provided.placeholder}
                                                                            </tbody>
                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>
                                                            </table>
                                                            {menuList.length > 0 ? <>
                                                                <button className="btn rounded-1 edit-submit-btn me-2 p-1 px-2 mb-3 mt-3" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                                <button className="btn rounded-1 add-sec-btn p-1 mx-3 px-2 mb-3 mt-3" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                            </> : <></>}
                                                        </Tab.Pane>
                                                        <Tab.Pane eventKey="Sub">
                                                            <div className="container-fluid">
                                                                <table className="table table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={{ width: '400px' }}>Name</th>
                                                                            <th style={{ width: '300px' }}>View Type</th>
                                                                            <th className="text-center" style={{ width: '300px' }}>Social Type</th>
                                                                            <th className="text-center" style={{ width: '400px' }}>Link</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                                            <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                                            <th className="text-right" style={{ width: '120px' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {cmsSubheaderData.length > 0 ? cmsSubheaderData.map((data) => (
                                                                            <tr key={data.tableId || data.SubheaderID}>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <input type="text" value={data.SubheaderName} onChange={(e) => this.handleChange(e, "SubheaderName")} />
                                                                                    ) : (
                                                                                        <span>{data.SubheaderName}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <select onChange={(e) => this.handleChange(e, "ViewType")} value={data.ViewType}>
                                                                                            <option value={""}></option>
                                                                                            <option value={"SM"}>Social Media</option>
                                                                                            <option value={"BTN"}>Button</option>
                                                                                        </select>
                                                                                    ) : (
                                                                                        <span>{data.ViewType}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <select disabled={data.ViewType == "BTN"} onChange={(e) => this.handleChange(e, "SocialType")} value={data.SocialType}>
                                                                                            <option value={""}></option>
                                                                                            <option value={"Email"}>Email</option>
                                                                                            <option value={"Phone"}>Phone</option>
                                                                                            <option value={"Facebook"}>Facebook</option>
                                                                                            <option value={"LinkedIn"}>LinkedIn</option>
                                                                                            <option value={"Twitter"}>Twitter</option>
                                                                                            <option value={"Instagram"}>Instagram</option>
                                                                                            <option value={"Youtube"}>Youtube</option>
                                                                                        </select>
                                                                                    ) : (
                                                                                        <span>{data.SocialType}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <input type="text" value={data.Link} onChange={(e) => this.handleChange(e, "Link")} />
                                                                                    ) : (
                                                                                        <span>{data.Link}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <div class="custom-control custom-checkbox"
                                                                                            onClick={(e) => this.handleChange(e, "isActive", !data.isActive)} >
                                                                                            <input type="checkbox" class="custom-control-input" checked={data.isActive} value={data.isActive} />
                                                                                            <label class="custom-control-label" ></label>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span>{data.isActive == true ? "Active" : "InActive"}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                                        <div class="custom-control custom-checkbox"
                                                                                            onClick={(e) => this.handleChange(e, "isPublish", !data.isPublish)} >
                                                                                            <input type="checkbox" class="custom-control-input" checked={data.isPublish} value={data.isPublish} />
                                                                                            <label class="custom-control-label" ></label>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <span>{data.isPublish == true ? 'Published' : "Unpublished"}</span>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    <div className="row">
                                                                                        <div className="col-3"><i className="far fa-edit" onClick={() => this.handleEdit(data.tableId || data.SubheaderID)} /></div>
                                                                                        <div className="col-3"><i className="far fa-plus-square" onClick={() => this.handleAddRow(data.tableId || data.SubheaderID)}></i></div>
                                                                                        <div className="col-3"><i className="far fa-save" onClick={() => this.submitSubmenu()} /></div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )) : (
                                                                            <tr><td colSpan={8}>No Record Found</td></tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </Tab.Pane>
                                                        <Tab.Pane eventKey="govtLogo">
                                                            <div className="container-fluid">
                                                                <div className="row g-3">
                                                                    <div className="col-12 text-center mt-2 d-flex align-items-center justify-content-center gap-2 mb-2">
                                                                        <button
                                                                            className="btn btn-primary me-2"
                                                                            onClick={this.addNewGovtLogo}
                                                                        >
                                                                            <i className="bi bi-plus-circle"></i> Add New Logo
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-success me-2"
                                                                            onClick={this.handleSaveGovtLogo}
                                                                        >
                                                                            <i className="bi bi-check-circle"></i> Submit
                                                                        </button>
                                                                    </div>

                                                                    {govtLogoList.map((item, index) => (
                                                                        <div className="col-md-4 mb-2" key={index}>
                                                                            <div className="card shadow-sm">
                                                                                <div className="card-body">
                                                                                    {/* File Upload + Preview */}
                                                                                    <div className="mb-3 text-center">
                                                                                        <input
                                                                                            type="file"
                                                                                            className="form-control mb-2"
                                                                                            accept="image/*"
                                                                                            onChange={(e) => this.handleFileChangeGovtLogo(e, index)}
                                                                                        />
                                                                                        <img
                                                                                            src={
                                                                                                item.formfile
                                                                                                    ? item.formfile
                                                                                                    : (
                                                                                                        downloadUrl + '/' +
                                                                                                        (item.GovtLogoFilepath
                                                                                                            ? item.GovtLogoFilepath.replace(/\\/g, "/")
                                                                                                            : "https://via.placeholder.com/150x80?text=Logo")
                                                                                                    ) || "https://via.placeholder.com/150x80?text=Logo"
                                                                                            }
                                                                                            alt="logo"
                                                                                            className="img-fluid rounded"
                                                                                            style={{ maxHeight: "80px" }}
                                                                                        />
                                                                                    </div>

                                                                                    {/* URL */}
                                                                                    <div className="mb-3">
                                                                                        <label className="form-label">URL</label>
                                                                                        <input
                                                                                            type="url"
                                                                                            className="form-control"
                                                                                            placeholder="https://example.com"
                                                                                            value={item.Link}
                                                                                            onChange={(e) =>
                                                                                                this.handleLinkGovtLogoChange(index, e.target.value)
                                                                                            }
                                                                                        />
                                                                                    </div>

                                                                                    {/* Toggles + Delete */}
                                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                                        {/* Active */}
                                                                                        <div className="form-check form-switch me-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                checked={item.isActive}
                                                                                                onChange={() =>
                                                                                                    this.handleToggleGovtLogo(index, "isActive")
                                                                                                }
                                                                                                id={`active-${index}`}
                                                                                            />
                                                                                            <label
                                                                                                className="form-check-label text-dark"
                                                                                                htmlFor={`active-${index}`}
                                                                                            >
                                                                                                Active
                                                                                            </label>
                                                                                        </div>

                                                                                        {/* Publish */}
                                                                                        <div className="form-check form-switch me-3">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                checked={item.isPublish}
                                                                                                onChange={() =>
                                                                                                    this.handleToggleGovtLogo(index, "isPublish")
                                                                                                }
                                                                                                id={`publish-${index}`}
                                                                                            />
                                                                                            <label
                                                                                                className="form-check-label text-dark"
                                                                                                htmlFor={`publish-${index}`}
                                                                                            >
                                                                                                Publish
                                                                                            </label>
                                                                                        </div>

                                                                                        {/* Delete */}
                                                                                        <button
                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                            onClick={() => this.deleteGovtLogo(index)}
                                                                                        >
                                                                                            <i className="bi bi-trash"></i> Delete
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Tab.Pane>
                                                    </Tab.Content>
                                                </Tab.Container>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                <Footer footerData={cmsFooterData} />

                <ToastContainer />
            </>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action, insertUpdateCmsSubheader_action, insertUpdateCMSGovtLogo_action, updateCmsGovtLogoStatus_action, updateCmsGovtLogoStatus_action })(cmsHeaderMaster));
